import React from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

// pas:1752-1759 — validação de rateio é por VALOR (soma de valores == valor lançamento),
// não por percentual. Percentual é derivado e exibido apenas para UX.
const GridRateio = ({
  rateios,
  onChange,
  valorTotal,
  disabled,
  opcoesDepartamento,
}) => {
  const valorTotalNum = parseFloat(valorTotal) || 0;

  const somaValores = (rateios || []).reduce(
    (s, r) => s + (parseFloat(r.valor) || 0),
    0
  );
  const somaPercentuais = (rateios || []).reduce(
    (s, r) => s + (parseFloat(r.percentual) || 0),
    0
  );
  const somaValorOk = valorTotalNum > 0
    && Math.abs(somaValores - valorTotalNum) < 0.01;

  const handleAdicionarLinha = () => {
    onChange([...(rateios || []), { departamento: null, percentual: '', valor: '' }]);
  };

  const handleRemoverLinha = (idx) => {
    const nova = (rateios || []).filter((_, i) => i !== idx);
    onChange(nova);
  };

  const handleChangeDepto = (idx, deptoValue) => {
    const nova = (rateios || []).map((r, i) => {
      if (i !== idx) return r;
      return { ...r, departamento: deptoValue };
    });
    onChange(nova);
  };

  // Edição de Percentual → recalcula Valor.
  const handleChangePercentual = (idx, perc) => {
    const nova = (rateios || []).map((r, i) => {
      if (i !== idx) return r;
      const percNum = parseFloat(perc) || 0;
      const valorCalc = valorTotalNum > 0 && percNum > 0
        ? ((valorTotalNum * percNum) / 100).toFixed(2)
        : '';
      return { ...r, percentual: perc, valor: valorCalc };
    });
    onChange(nova);
  };

  // Edição de Valor → recalcula Percentual (pas:1752-1759 — valor é a fonte).
  const handleChangeValor = (idx, valor) => {
    const nova = (rateios || []).map((r, i) => {
      if (i !== idx) return r;
      const valorNum = parseFloat(valor) || 0;
      const percCalc = valorTotalNum > 0 && valorNum > 0
        ? ((valorNum / valorTotalNum) * 100).toFixed(4)
        : '';
      return { ...r, valor, percentual: percCalc };
    });
    onChange(nova);
  };

  const formatarValor = (v) => {
    if (v == null || v === '') return 'R$ 0,00';
    return Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <strong style={{ fontSize: '0.9rem' }}>Rateio</strong>
        {!disabled && (
          <Button variant="outline-secondary" style={{ padding: '2px 8px', fontSize: '0.8rem' }} onClick={handleAdicionarLinha}>
            <FaPlus className="mr-1" /> Adicionar Departamento
          </Button>
        )}
      </div>
      <Table bordered size="sm" className="mb-1">
        <thead>
          <tr>
            <th>Departamento</th>
            <th style={{ width: 110 }}>% Rateio</th>
            <th style={{ width: 140 }}>Valor</th>
            {!disabled && <th style={{ width: 40 }} />}
          </tr>
        </thead>
        <tbody>
          {(rateios || []).map((r, idx) => (
            <tr key={`rateio-${r.departamento || idx}-${idx}`}>
              <td>
                {disabled ? (
                  <span>{(opcoesDepartamento.find((o) => o.value === r.departamento) || {}).label || r.departamento || '-'}</span>
                ) : (
                  <Select
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    options={opcoesDepartamento}
                    value={opcoesDepartamento.find((o) => o.value === r.departamento) || null}
                    onChange={(sel) => handleChangeDepto(idx, sel ? sel.value : null)}
                    placeholder="Selecione..."
                    noOptionsMessage={() => 'Nenhum'}
                  />
                )}
              </td>
              <td>
                {disabled ? (
                  <span>{r.percentual ? `${parseFloat(r.percentual).toFixed(2)}%` : '-'}</span>
                ) : (
                  <Form.Control
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    value={r.percentual}
                    onChange={(e) => handleChangePercentual(idx, e.target.value)}
                    style={{ fontSize: '0.85rem' }}
                  />
                )}
              </td>
              <td>
                {disabled ? (
                  <span>{formatarValor(r.valor)}</span>
                ) : (
                  <Form.Control
                    type="number"
                    min="0"
                    step="0.01"
                    value={r.valor}
                    onChange={(e) => handleChangeValor(idx, e.target.value)}
                    style={{ fontSize: '0.85rem' }}
                  />
                )}
              </td>
              {!disabled && (
                <td className="text-center">
                  <Button
                    variant="outline-danger"
                    style={{ padding: '1px 6px' }}
                    onClick={() => handleRemoverLinha(idx)}
                  >
                    <FaTrash />
                  </Button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
      <Table bordered size="sm" className="mb-1">
        <tbody>
          <tr>
            <td style={{ width: '50%' }}>
              <strong>Soma %:</strong>{' '}
              <span className={Math.abs(somaPercentuais - 100) < 0.01 ? 'text-success' : 'text-danger'}>
                {somaPercentuais.toFixed(2)}%
              </span>
            </td>
            <td>
              <strong>Soma Valor:</strong>{' '}
              <span className={somaValorOk ? 'text-success' : 'text-danger'}>
                {formatarValor(somaValores)}
              </span>
              {valorTotalNum > 0 && (
                <>
                  {' / '}
                  <span>{formatarValor(valorTotalNum)}</span>
                </>
              )}
            </td>
          </tr>
        </tbody>
      </Table>
      <div style={{ fontSize: '0.82rem' }}>
        {somaValorOk ? (
          <span className="text-success">Rateio confere com o valor do lançamento.</span>
        ) : (
          <span className="text-danger">
            Rateio divergente: soma dos valores deve ser igual ao valor do lançamento.
          </span>
        )}
      </div>
    </div>
  );
};

export default GridRateio;
